/**
 * The European markets plant.habb.me ships to, as DATA.
 *
 * A market is a country with its own planting reality — hardiness range, native
 * flora, planting calendar — and one or more languages it is served in. Adding a
 * market is an entry here plus a message catalogue; it is never a code change in
 * the router or the shell (NFR-07, NFR-08).
 *
 * `code` is ISO 3166-1 alpha-2, lowercased. `languages` are ISO 639-1, and the
 * FIRST entry is that market's default — the language a visitor gets when we know
 * their country but not their language preference.
 */
export const MARKETS = [
    {
        code: 'at',
        name: 'Österreich',
        englishName: 'Austria',
        languages: ['de', 'en'],
    },
    {
        code: 'hu',
        name: 'Magyarország',
        englishName: 'Hungary',
        languages: ['hu', 'en'],
    },
];

/**
 * The locale a visitor lands on when nothing about them matches a supported
 * market — an unrouted European visitor still gets a real, complete experience
 * rather than a 404 or an empty shell.
 */
export const FALLBACK_LOCALE = 'at-en';

export function findMarket(marketCode) {
    return MARKETS.find((market) => market.code === marketCode) || null;
}

export function getMarketDefaultLanguage(marketCode) {
    const market = findMarket(marketCode);

    return market ? market.languages[0] : null;
}

/** Every language used by at least one market — the set of catalogues we must ship. */
export function listSupportedLanguages() {
    return [...new Set(MARKETS.flatMap((market) => market.languages))];
}
